<template>
    <div class="video--container embed-responsive embed-responsive-16by9">
        <video allowfullscreen muted controls loop autoplay preload="none" class="border-0">
            <source :src="`${MEDIA_URL}video-corporativo-torbel-low.mp4`" type="video/mp4"/>
        </video>
    </div>
</template>
<script>
import { MEDIA_URL } from "@/config";

export default {
    name: 'VideoEmpresa',
    data() {
        return {
            MEDIA_URL
        }
    }
}
</script>
<style lang="scss" scoped></style>